import styled from 'styled-components';
import { mediaMax } from '../Media Template/Media Template';

export const Title = styled.div.attrs({
  className: 'Title',
  family: props => props.fontFamily,
  size: props => props.fontSize,
  weight: props => props.fontWeight,
  fontStyle: props => props.fontstyle,
  lineheight: props => props.lineHeight,
  letterSpacing: props => props.letterSpacing,
  padding: props => props.padding,
  color: props => props.color || '#212121',
  marginforp: props => props.marginforp || '0',
  backgroundimage: props => props.backgroundImage,
  backgroundclip: props => props.backgroundClip
})`
  font-family: ${props => props.family};
  font-size: ${props => props.size};
  font-weight: ${props => props.weight};
  font-style: ${props => props.fontStyle};
  line-height: ${props => props.lineheight};
  letter-spacing: ${props => props.letterSpacing};
  padding: ${props => props.padding};
  color: ${props => props.color};
  background-image: ${props => props.backgroundimage};
  background-clip: ${props => props.backgroundclip};
  -webkit-background-clip: ${props => props.backgroundclip};
  background-clip: ${props => props.backgroundclip};
  -webkit-text-fill-color: ${props => props.color};
  p {
    margin: ${props => props.marginforp};
  }
  ${mediaMax.phone`
    line-height: normal;
    letter-spacing: normal;
  `};
`;
